<template>
    <div class="vue-template">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12 mb-3">
                    
                    <div class="row justify-content-start mb-3">
                       <div class="col-md-12 text-center" style="height:70vh">
                           <img src="@/assets/img/pencil404.png" width="200px" class="img-fluid" />
                <span class="display-1 d-block">404</span>
                <div class="mb-4 lead">The page you are looking for was not found.</div>
                <router-link to='/my-account' class="btn btn-link">Back to Dashboard</router-link>
            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'notices',
        components: {
        },
        data () {
            return {}
        },
        methods: {
        }
    };
</script>

<style scoped>
    .student-helpbot-child-card{
        background: #d3d3d37a;
        border-radius: 0;
    }
</style>